export default "__VITE_ASSET__DpiTCi9Q__"